





















































import clickOutside from '@/directives/clickOutside';
import { Component, Prop, Vue } from 'vue-property-decorator';
import TruncatedText from '@/components/TruncatedText.vue';

interface Option {
  value: string | number;
  label: string;
}

type OpenDirection = 'top' | 'down';

@Component({
  components: {
    TruncatedText,
  },
  directives: {
    clickOutside,
  },
})
export default class MultiSelect extends Vue {
  @Prop({ type: Array, default: () => [] }) readonly options!: Array<string | Option>;
  @Prop({ type: Array, default: () => [] }) readonly value!: Array<string | number>;
  @Prop({ type: String, default: 'down' }) readonly openDirection!: OpenDirection;

  dropdownOpen: boolean = false;
  selected: Array<string | number> = [];

  created () {
    this.selected = [...this.value];
  }

  get normalizedOptions (): Option[] {
    return this.options.map(option => typeof option === 'string' ? { value: option, label: option } : option);
  }

  get selectedOptions (): Option[] {
    return this.normalizedOptions.filter(option => this.selected.includes(option.value));
  }

  get dropdownPositionClass (): string { return this.openDirection === 'top' ? 'dropdown-up' : 'dropdown-down'; }

  toggleDropdown (): void {
    this.dropdownOpen = !this.dropdownOpen;
  }

  closeDropdown (): void {
    this.dropdownOpen = false;
  }

  toggleOption (val: string | number): void {
    const index = this.selected.indexOf(val);
    if (index === -1) {
      this.selected.push(val);
    } else {
      this.selected.splice(index, 1);
    }
    this.$emit('input', this.selected);
  }

  isSelected (val: string | number): boolean {
    return this.selected.includes(val);
  }

  removeOption (val: string | number): void {
    const index = this.selected.indexOf(val);
    if (index !== -1) {
      this.selected.splice(index, 1);
      this.$emit('input', this.selected);
    }
  }

  handleTouch (val: string | number): void {
    this.toggleOption(val);
  }
}
